// #000000 -> 0,0,0 으로 변환
export const hex_to_rgb = (hex) => {
    return hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16))
        .join(",");
};

// 0,0,0 -> #000000 으로 변환
export const rgb_to_hex = (rgb) => {
    let color =
        "#" +
        rgb
            .split(",")
            .map((x) => parseInt(x).toString(16).padStart(2, "0"))
            .join("");
    if (color === "#NaN") {
        color = "#000000";
    }
    return color;
};

export const random_range = (from, to, is_decimal = false) => {
    if (is_decimal) {
        return Math.random() * (to - from) + from;
    } else {
        from = Math.ceil(from);
        to = Math.floor(to);
        return Math.floor(Math.random() * (to - from + 1)) + from;
    }
};

// return promise
export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const insert_at = (array, index, item) => {
    array.splice(index, 0, item);
};

export const select = (flag, a = null, b = null) => {
    return flag ? a : b;
};

export const select_keys = (object, keys) => {
    // delete 로 구현할 가능성
    let new_object = {};

    keys.forEach((key) => {
        new_object[key] = object[key];
    });

    return new_object;
};

export const select_without_keys = (object, keys) => {
    let new_object = {...object};
    keys.forEach((key) => {
        delete new_object[key];
    });

    return new_object;
};

// expire_time: in millis
export const storage_get = (key) => {
    let result = null;
    try {
        result = JSON.parse(localStorage.getItem(key));
        if (result.expire_time && result.time + result.expire_time < new Date().getTime()) {
            // expired
            result = null;
        }
    } catch {}
    return result?.value || null;
};

export const storage_set = (key, value, expire_time = null) => {
    let current_time = new Date().getTime();
    localStorage.setItem(
        key,
        JSON.stringify({
            value: value,
            time: current_time,
            expire_time: expire_time,
        })
    );
};

export const storage_remove = (key) => {
    localStorage.removeItem(key);
};

// 생년월일에 '-' 자동으로 추가
export const autoHyphenBirthDate = (str) => {
    str = str.replace(/[^0-9]/g, "");
    if (str.length < 5) {
        return str;
    } else if (str.length < 7) {
        return str.substr(0, 4) + "-" + str.substr(4);
    } else {
        return str.substr(0, 4) + "-" + str.substr(4, 2) + "-" + str.substr(6);
    }
};

// 휴대폰에 '-' 자동으로 추가
export const autoHyphenPhoneNumber = (str) => {
    str = str.replace(/[^0-9]/g, "");
    if (str.length < 4) {
        return str;
    } else if (str.length < 7) {
        return str.substr(0, 3) + "-" + str.substr(3);
    } else if (str.length < 11) {
        return str.substr(0, 3) + "-" + str.substr(3, 3) + "-" + str.substr(6);
    } else {
        return str.substr(0, 3) + "-" + str.substr(3, 4) + "-" + str.substr(7);
    }
};

// 문자열의 길이가 길면 끝을 '...'으로 표현
export const getVisibleString = (str, length) => {
    let str_array = str.split("");
    let tmp_array = [];
    if (str.length >= length) {
        for (let i = 0; i < length - 2; i++) {
            tmp_array.push(str_array[i]);
        }
        tmp_array.push("...");
        return tmp_array.join("");
    } else {
        return str;
    }
};

// 수강률 반환
// (attendance_rate : 각 강의 수강률(소수 한 자리), total_attendance_rate : 한 직원의 전체 수강률)
export const getPercentage = (num, type = "attendance_rate") => {
    if (type === "attendance_rate") {
        if (num >= 1) {
            return 100;
        } else if (num === 0) {
            return 0;
        } else {
            return (num * 100).toFixed(1);
        }
    } else {
        return Math.round(num * 100);
    }
};

// 초 단위의 second 를 시간과 분을 나눠서 반환
export const getVisibleHourAndMinute = (second) => {
    let hour;
    let minute;
    if (second / 60 / 60 < 1) {
        hour = 0;
        minute = Math.floor(second / 60);
    } else {
        hour = Math.floor(second / 60 / 60);
        minute = Math.floor(second % 60);
    }
    return {hour, minute};
};
